<template>
  <div ref="mainHolder" class="overflow-hidden">
    <div ref="bannersHolder" class="mb-2" :style="{width: `${bannersHolderWidth}px`}">
      <div class="flex" :style="{marginLeft: `${bannersMargin}px`, transition: fakedSlide ? 'none' : 'margin-left 0.6s ease-in'}">
        <div
          class="flex-none"
          :key="`banner-${i}`"
          :style="{width: `${mainHolderWidth}px`}"
          v-for="(banner, i) in shownBanners">
          <a
            class="text-center block"
            :href="banner.link"
            :target="banner.link_target">
            <template v-if="banner.is_video">
              <div key="small-vid" v-if="smallRes">
                <video playsinline muted autoplay class="w-full h-auto">
                  <source :src="banner.image_small_full_path" type="video/mp4">
                </video>
              </div>
              <div key="large-vid" v-else>
                <video playsinline muted autoplay class="w-full h-auto">
                  <source :src="banner.image_full_path" type="video/mp4">
                </video>
              </div>
            </template>
            <template v-else>
              <img :src="banner.image_full_path" :class="banner.image_small_full_path != null ? 'hidden md:inline' : 'inline'" class="rounded-lg">
              <img :src="banner.image_small_full_path" class="inline md:hidden rounded-lg" v-if="banner.image_small != null">
            </template>
            </a>
          <p class="text-2xs py-1 leading-none">{{ banner.terms }}</p>
        </div>
      </div>
    </div>

    <div class="text-center">
      <div class="inline-block rounded-full pl-2 pr-1" style="background-color:rgba(0,0,0,0.48)">
        <div
          class="rounded-full bg-white p-1 inline-block mr-1 cursor-pointer opacity-50"
          :key="`indicator-${i}`"
          :class="currentBanner == i ? 'opacity-100' : 'opacity-50'"
          @click="currentBanner = i"
          v-for="(banner, i) in banners"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home-banner',
  props: {
    banners: {
      type: Array,
      default() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      shownBanners: [],
      mainHolderWidth: 0,
      bannersHolderWidth: 0,
      bannersMargin: 0,
      currentBanner: 0,
      timeout: null,
      bannerHeight: 0,
      smallRes: false,
      fakedSlide: false,
    }
  },
  mounted() {
    window.addEventListener('resize', this.callCheckRes);
    this.checkRes();
    
    document.body.addEventListener('keyup', this.keyUp);

    this.banners.forEach(banner => {
      this.shownBanners.push(banner);
    });

    if (this.banners.length > 1) {
      this.setTimer();

      if (this.banners.length > 2) {
        this.shownBanners.push(this.banners[0]);
      }
    }
  },
  beforeDestroy() {
    document.body.removeEventListener('keyup', this.keyUp);
  },
  watch: {
    currentBanner(newVal) {
      this.updateMargin();
      // this.setTimer();
    }
  },
  methods: {
    /**
    * Calls the check-resolution method
    */
    callCheckRes() {
      this.checkRes();
    },
    /**
     * Checks the window resolution in order to determine the new width
     */
    checkRes() {
      this.smallRes = (window.innerWidth < 640);
      
      if (this.mainHolderWidth == this.$refs.mainHolder.offsetWidth) {
        return;
      }

      this.mainHolderWidth = this.$refs.mainHolder.offsetWidth;
      this.bannersHolderWidth = (this.mainHolderWidth) * this.banners.length;
      this.updateMargin();
    },
    keyUp(e) {
      if (e.keyCode === 37) {
        this.prevBanner();
      } else if (e.keyCode === 39) {
        this.nextBanner();
      }
    },
    prevBanner() {
      if (this.currentBanner == 0) {
        this.currentBanner = this.banners.length - 1;
      } else {
        this.currentBanner--;
      }

      this.setTimer();
    },
    nextBanner() {
      if (this.currentBanner == (this.shownBanners.length - 1)) {
        this.currentBanner = 0;
      } else {
        this.currentBanner++;
      }

      this.setTimer();
    },
    updateMargin() {
      this.bannersMargin = 0 - (this.currentBanner * this.mainHolderWidth);
    },
    setTimer() {
      clearTimeout(this.timeout);

      if (this.banners.length > 2) {
        if (this.currentBanner == this.banners.length) {
          setTimeout(() => {
            this.fakedSlide = true;
            this.currentBanner = 0;
            setTimeout(() => {
              this.fakedSlide = false;
            }, 250);
          }, 600);
        }
      }

      this.timeout = setTimeout(() => {
        this.nextBanner();
      }, (this.shownBanners[this.currentBanner].duration * 1000) + 600);
    }
  }
}
</script>
